/* unplugin-vue-components disabled */import { render } from "./Upload.vue?vue&type=template&id=475fed03"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__